import { render, staticRenderFns } from "./InsightSubmitScore.vue?vue&type=template&id=07f13fc0"
import script from "./InsightSubmitScore.vue?vue&type=script&lang=js"
export * from "./InsightSubmitScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports